import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconsModule } from '../../design/icons.module';
import { DialogModule } from '../dialog/dialog.module';
import { InlineConfirmComponent } from './inline-confirm.component';

@NgModule({
  declarations: [InlineConfirmComponent],
  imports: [CommonModule, IconsModule, DialogModule],
  exports: [InlineConfirmComponent]
})
export class InlineConfirmModule { }
